import { Injectable } from '@angular/core';
import { ToasterService } from 'angular2-toaster';
import { CryptoEncService } from './crypto-enc.service';

@Injectable()
export class MailedInvoiceSessionService {
  private readonly storageKeys: string[] = [
    'mailedInvoice',
    'mailedInvoiceId',
    'originalInvoiceId',
    'mailedInvoiceData',
    'invoiceType',
    'grnList',
    'multiGrnPayload',
    'tpScanData',
    'redirect_page_url',
    'global_origin_company_id',
    'mailed_invoice_pagination',
    'invoice_id',
    'show_multi_inv',
    'invoice_screen',
    'invoice_for_approval_screen'
  ];

  private writeFailed: boolean = false;

  constructor(private toasterService: ToasterService, private cryptoEncService: CryptoEncService) { }

  beginWrite(): void {
    this.writeFailed = false;
  }

  getItem(key: string): string | null {
    try {
      return sessionStorage.getItem(key);
    } catch (e) {
      return null;
    }
  }

  readJson(key: string): any {
    const raw = this.getItem(key);
    if (!raw) {
      return null;
    }
    const plain = this.tryParse(raw);
    if (plain) {
      return plain;
    }
    try {
      const decrypted = this.cryptoEncService.decrypt(raw);
      return this.tryParse(decrypted);
    } catch (e) {
      return null;
    }
  }

  setItem(key: string, value: any): void {
    try {
      sessionStorage.setItem(key, value == null ? '' : String(value));
      this.removeLocalCopy(key);
    } catch (e) {
      this.writeFailed = true;
    }
  }

  removeItem(key: string): void {
    try {
      sessionStorage.removeItem(key);
    } catch (e) { }
    this.removeLocalCopy(key);
  }

  clear(): void {
    for (let i = 0; i < this.storageKeys.length; i++) {
      this.removeItem(this.storageKeys[i]);
    }
  }

  stopIfWriteFailed(clearStoredData: boolean = true): boolean {
    if (!this.writeFailed) {
      return false;
    }
    this.writeFailed = false;
    if (clearStoredData) {
      this.clear();
    }
    this.toasterService.pop('error', 'Error', 'This invoice is too large to open in this tab. Please try again.');
    return true;
  }

  private removeLocalCopy(key: string): void {
    try {
      localStorage.removeItem(key);
    } catch (e) { }
  }

  private tryParse(value: string): any {
    try {
      return JSON.parse(value);
    } catch (e) {
      return null;
    }
  }
}



// WEBPACK FOOTER //
// /codebuild/output/src825240186/src/src/app/shared/services/mailed-invoice-session.service.ts